import { useTranslation } from 'react-i18next';
import SuccessScreen from '@/components/ui/SuccessScreen/SuccessScreen';

interface AddClassificationSuccessScreenProps {
  onBackToSupporteds: () => void;
  onAddAnotherClassification: () => void;
  /** HAT-1453: lets the coordinator carry straight on to a support request for this supported. */
  onGoToRequest?: () => void;
}

const AddClassificationSuccessScreen = ({ onBackToSupporteds, onAddAnotherClassification, onGoToRequest }: AddClassificationSuccessScreenProps) => {
  const { t } = useTranslation();

  return (
    <SuccessScreen
      title={t('classificationAddedSuccessfully')}
      description={t('classificationReviewMessage')}
      primaryButtonText={t('backToSupporteds')}
      primaryButtonAction={onBackToSupporteds}
      secondaryButtonText={t('addAnotherClassification')}
      secondaryButtonAction={onAddAnotherClassification}
      extraButtons={onGoToRequest ? [{ text: t('goToSupportRequest'), action: onGoToRequest }] : []}
    />
  );
};

export default AddClassificationSuccessScreen;
